export const columnHeaderStyle = {
    backgroundColor: "#0d3b59",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "12px",
    textAlign: "center",
    padding: "8px",
};

export const columnBodyStyle = {
    fontSize: "12px",
    padding: "8px",
    textAlign: "center",
    verticalAlign: "middle",
};

export const genderColumnHeaderStyle = {
    backgroundColor: "#0d3b59",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    width: "250px",
};

export const genderColumnBodyStyle = {
    fontSize: "14px",
    padding: "10px",
    textAlign: "center",
    width: "250px",
};
